import { fetchProfile } from '@api/useQueryCalls';
import ProfileAppVersion from '@atoms/ProfileAppVersion';
import ShimmerProfile from '@atoms/Shimmers/ShimmerProfile';
import { View } from '@components/primitives';
import useFeatureFlag from '@customHooks/useFeatureFlag';
import Header from '@molecules/Header';
import ProfileBankDetails from '@molecules/ProfileBankDetails';
import ProfileBonus from '@molecules/ProfileBonus';
import ProfileHeader from '@molecules/ProfileHeader';
import ProfileInformation from '@molecules/ProfileInformation';
import ProfileLogoutButton from '@molecules/ProfileLogoutButton';
import ProfileReferral from '@molecules/ProfileReferral';
import ProfileSecurityPin from '@molecules/ProfileSecurityPin';
import { useIsFocused } from '@react-navigation/native';
import appStyles from '@root/appStyles';
import { FEATURE_FLAGS } from '@root/constants';
import { getStore } from '@store/storeUtils';
import React, { useEffect, useState } from 'react';
import { ScrollView } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import logProfileTab from './analyticsProfieltab';

const ProfileTab: React.FC = () => {
  const isFocused = useIsFocused();
  const { setDefaultBank, defaultBank, employeeProfile } = getStore();
  const [promotionBanner, setPromotionBanner] = useState<any[]>([]);

  const [isFeatureAvailale, getFeatureFlags] = useFeatureFlag({
    featureName: [
      FEATURE_FLAGS.GOLD_SAVINGS,
      FEATURE_FLAGS.MUL_BANK_ACC,
      FEATURE_FLAGS.BANK_SEL_TRNSF,
      FEATURE_FLAGS.PHONE_ENROLL,
      FEATURE_FLAGS.SALARY_INFO,
      FEATURE_FLAGS.SECURITY_PIN,
      FEATURE_FLAGS.PIC_REFERRAL,
      FEATURE_FLAGS.PHONE_NUMBER_CHANGE,
    ],
  });

  const isPIC: boolean = !!employeeProfile?.influencerRole && employeeProfile.influencerRole === 'PIC';

  useEffect(() => {
    if (isFocused) {
      getFeatureFlags();
    }
  }, [isFocused]);

  useEffect(() => {
    if (isFocused) logProfileTab(isPIC);
  }, [isFocused, isPIC]);

  const { isLoading, isError, error, data, isSuccess, refetch } = fetchProfile();

  useEffect(() => {}, [isError, error]);

  useEffect(() => {
    if (isSuccess && data) {
      setDefaultBank(data.account);
      setPromotionBanner(data.bannerSection);
    }
  }, [isSuccess, data]);

  useEffect(() => {
    if (isFocused) refetch();
  }, [isFocused]);

  return (
    <SafeAreaView edges={['top']} style={appStyles.outerContainer}>
      <View style={appStyles.tabParent}>
        <Header />
        {isLoading ? (
          <ShimmerProfile />
        ) : (
          <ScrollView>
            <ProfileHeader isPICReferral={isFeatureAvailale[FEATURE_FLAGS.PIC_REFERRAL]?.show} />
            {isFeatureAvailale[FEATURE_FLAGS.MUL_BANK_ACC]?.show ? (
              <ProfileBankDetails
                showBankDetails={isFeatureAvailale[FEATURE_FLAGS.MUL_BANK_ACC]?.show}
                defaultBank={defaultBank}
              />
            ) : null}
            {isFeatureAvailale[FEATURE_FLAGS.PIC_REFERRAL]?.show ? (
              <ProfileBonus showBonus={isFeatureAvailale[FEATURE_FLAGS.PIC_REFERRAL]?.show} />
            ) : null}
            <ProfileInformation
              showPhoneEnroll={isFeatureAvailale[FEATURE_FLAGS.PHONE_ENROLL]?.show}
              showSalaryInfo={isFeatureAvailale[FEATURE_FLAGS.SALARY_INFO]?.show}
            />
            {isFeatureAvailale[FEATURE_FLAGS.SECURITY_PIN]?.show ? (
              <ProfileSecurityPin
                showSecurityPin={isFeatureAvailale[FEATURE_FLAGS.SECURITY_PIN]?.show}
                showPhoneChange={isFeatureAvailale[FEATURE_FLAGS.PHONE_NUMBER_CHANGE]?.show}
              />
            ) : null}
            <ProfileReferral promotionData={promotionBanner?.banners} headerText={promotionBanner?.header} />
            {/* <ProfileWhatsapp isPIC={isPIC} /> */}
            <ProfileLogoutButton />
            <ProfileAppVersion />
          </ScrollView>
        )}
      </View>
    </SafeAreaView>
  );
};

export default ProfileTab;
